import React, {Component} from 'react';
import LinesEllipsis from 'react-lines-ellipsis';

import PortrateImg from "../../static/assets/img/item/portrate.jpg";
import Pr from "../../static/assets/img/prem.jpg";

const RadioSingleItem = ({itemImg, itemTitle, itemTitleBottom, premium}) => {
    return (
        <div className="radioSingleItem">
            <div className="itemImgWrap">
                {/* <span className="premium">{premium}</span> */}
                {premium === "1" && <span className="premium">Premium</span>}
                <div className="itemImg">
                    <img src={itemImg} alt="item img" className="img-fluid"/>
                </div>
                <div className="itemDetails">
                    {itemTitle &&
                    <div className="itemTitle">
                        <p><LinesEllipsis
                    text={itemTitle}
                    maxLine='1'
                    ellipsis='...'
                    trimRight
                    basedOn='letters'
                    /></p>
                    </div>
                    }
                    <div className="playIcon">
                        <i className="fas fa-play"></i>
                    </div>
                </div>

            </div>
            {itemTitleBottom &&
            <div className="itemTitle">
                <p><LinesEllipsis
                    text={itemTitleBottom}
                    maxLine='1'
                    ellipsis='...'
                    trimRight
                    basedOn='letters'
                    />
                </p>
            </div>
            }
        </div>
    );
}


export default RadioSingleItem;